// @ts-strict-ignore
import { default as ErrorComponent } from '@components/Error'
import { getServerSideTranslations } from '@lib/get-server-side-translations'
import { GetStaticProps, NextPage } from 'next'

type Props = {}

const NotFound: NextPage<Props> = () => {
  return <ErrorComponent statusCode={404} />
}

export const getStaticProps: GetStaticProps = async ({ locale }) => {
  return {
    props: {
      ...(await getServerSideTranslations(locale)),
    },
  }
}

export default NotFound
